// module.exports = {}
/* */
export default {
    button: {
        add: "Lägg till",
        clone: "Klona",
        delete: "Radera",
        deleteFeedback: "Radera feedback",
        open: "Öppen",
        save: "Spara",
        view: "Visa",
        prev: "Föreg.",
        previous: "föregående",
        next: "Nästä",
        yes: "Ja",
        no: "Nej"
    },
    customer: {
        editor: {
            confirmDelete: "Are you sure you want to delete this customer?",
            typeCustomerName: "Type customer name to confirm removal",
            name: "Kundredaktör",
            email: "Kundens e-post",
        },
        showDisabled: "Visa inaktiverade klienter",
    },
    clipboard: {
        copied: "Kopierat!"
    },
    login: {
        in: "Logga in",
        out: "Logga ut",
    },
    main: {
        admin: "Systemadministratör",
        auth0uid: "Auth0 uid",
        contact: "Kontakt",
        customer: "Kund",
        customers: "Kunder",
        dashboardEditor: "Övervakningsredigerare",
        dashboards: "Monitor",
        email: "E-post",
        name: "Namn",
        targets: "Mål",
        users: "Änvändare",
        welcome: "Välkommen till {{application}}",
        password: "Löseord",
    },
    user: {
        showDisabled: "Visa funktionshindrade användare",
        editor: {
            name: "Användarredigerare",
            auth0uid: "Auth0 uid",
            disabled: "Används inte",
        },
    },
    timestamps: {
        createdAt: "Skapades",
        updatedAt: "Uppdaterades",
        timeAt: "kl.",
    },
    target: {
        showDisabled: "Visa inaktiverade mål",
        editor: {
            name: "Målredaktör",
            available: "Tillgängliga föremål",
            button: {
                add: "Lägg till nytt mål",
                addLocalisation: "Lägg till lokalisering",
                addQuestionLocalisation: "Lägg till frågelokalisering",
                addThankYouLocalisation: "Lägg till en lokalisering på tacksidan",
                admin: "Systemadministratör",
                clone: "Klon",
                contact: "Kontakt",
                custom: "Kund",
                default: "Standardvärde",
                disabled: "Inaktiverad",
                enable: "Aktivera",
                enabled: "Aktiv",
                feel: "Vibrafon",
                generate: "Generera QR-koden med texter",
                generateWithoutTexts: "Generera QR-koden utan texter",
                marketing: "Marknadsföring",
                next: "Nästa",
                nps: "NPS",
                open: "Öppna",
                picture: "Eller klicka här för att välja en bild",
                plus: "Plus",
                previous: "Föregående",
                qrCodeGenerator: "QR code generator",
                reversed: "Omvänt",
                save: "Spara",
                special: "Special",
                super: "Super",
                view: "Visa",

            },
            label: {
                additionalQuestions: "Ytterligare frågor",
                baseTarget: "Använd detta som basmål för kedjan",
                button1: "Knapp 1",
                button2: "Knapp 2",
                button3: "Knapp 3",
                button4: "Knapp 4",
                button5: "Knapp 5",
                button6: "Knapp 6",
                button7: "Knapp 7",
                button8: "Knapp 8",
                category: "Kategori",
                customer: "Kund",
                description: "Beskrivning",
                enable: "Aktivera",
                endPage: "Slitsidan",
                feedbackQuestionNegative: "Feedback-fråga om negativ (-)",
                feedbackQuestionNeutral: "Feedback-fråga om neutral",
                feedbackQuestionPositive: "Feedback-fråga om positiv (+)",
                getback: "Återgå till detta efter det sista målet",
                iconsOrder: "Ordning av ikonen",
                iconsPath: "Ikoneras väg",
                imageButton: "Bildknapp",
                languageMenu: "Språkmenu",
                legalNotice: "Dataskydd",
                legalNoticeURL: "Dataskydd URL-länk",
                linked: "Länkad",
                locationEnabled: "Platsdata aktiverad",
                lotteryRules: "Regler för lotteriet",
                lotteryRulesURL: "Regler URL-länk",
                maxValue: "Max värde",
                measurementType: "Mätning",
                minValue: "Min värde",
                noVoting: "Betyget är inte frågat",
                optionalFields: "Valfria fält",
                optionalQuestions: "Valfria frågor",
                otherSettings: "Andra inställningar",
                parent: "Förälder",
                picture: "Bild",
                question: "Fråga",
                showNPSfooter: "Visa NPS-sidfot",
                skipButton: "Hoppa över knapp",
                subtitle: "Undertitel",
                tags: "Taggar",
                thanksText: "Tack text",
                thankYouPage: "Taksidan",
                theme: "Teema",
                title: "Titel",
                topicButtons: "Ämnesknappar",
                topicButtonsSubtitle: "Texta",
                topicButtonsTitle: "Titel",
                votingLimit: "Röstgräns",
                votingLimitKey: "Nyckel för röstgrens",
                votingLimitTime: "Rösgrens is sekunder",
                votingScale: "Röstskala",
                whistleblower: "Whistleblower",
                dropZeroNPS: "Släpp noll NPS med tom feedback",
                dropNegativeNPS: "Släpp negativ NPS med tom feedback",
                noAutosubmitWhenEmpty: "Inaktivera autosubmit med tom feedback",
            },
            confirmDelete: "Are you sure you want to delete target: ",
            confirmDeleteFeedback: "Are you sure you want to delete feedback given to target: ",
            contact: {
                contactMe: "Ta kontakt",
                contactFormTitle: "Kontaktformulärets titel",
                showName: "Visa namn",
                showCompany: "Visa företag",
                showEmail: "Visa e-post",
                showPhone: "Visa telefonnummer",
                showRoom: "Visa rumsnummer",
                showTeam: "Visa team",
                showAddress: "Visa addres",
                showZIP: "Visa postnummer",
                showCity: "Visa stad",
                showCountry: "Visa land",
                showAge: "Visa ålder",
                showGenre: "Visa kön",
                title: "Kontakt",
            },
            custom: {
                custom1: "Custom 1",
                custom2: "Custom 2",
                custom3: "Custom 3",
                custom4: "Custom 4",
                custom5: "Custom 5",
                custom6: "Custom 6",
                title: "Custom",
            },
            marketing: {
                noSMS: "Inga marknadsföringstextmeddelanden",
                noEmail: "Inden marknadsförings-e-post",
                noCall: "Ingen telemarketing",
                noText: "Inga marknadsföringsmeddelanden",
                title: "Marknadsföring",
            },
            special: {
                linkingTarget: "Länkat mål",
                styleSettings: "Stilinställningar",
                title: "Specialerbjudanden",
            },
            qrCode: {
                scale: "QR-kodstorlek",
                title: "QR-kods titel",
                URL: "QR-kods URL-länk",
                warning: "Testa alltid QR-koden före användning",
            },
            question: {
                add: "Lägg till",
            },
        },
    },
    dashboard: {
        name: "Övervakningsredigerare",
        showDisabled: "Visa funktionshindrade monitorer",
        editor: {
            available: "Tillgängliga monitorer",
            authenticated: "Autentiserat",
            availableDashboards: "Valbara monitorer",
            availableTargets: "Tillgängliga monitorer",
            buttonVisibility: "Responsknapparnas synlighet",
            // users: "Users",
            chart: {
                showFeelings: "Sentiment-mätare",
                showCustomerFeelings: "Kund Sentiment-mätare",
                showEmployeeFeelings: "Arbetare Sentiment-mätare",
                showHistory: "Historikplotter",
                showNPS: "NPS-mätare",
                showENPS: "eNPS-mätare",
                showNPSDis: "NPS-distribution",
                showPie: "Paj",
                showPlus: "Plus-mätare",
                showOverviewIcon: "Översikt ikon"
            },
            chartVisibility: "Mätarnas synlighet",
            commentsbcc: "Kommentarer Bcc",
            confirmDelete: "Are you sure you want to delete this dashboard",
            disabled: "Monitoren inaktiverad",
            enableAnalytics: "Rapports beställningsmöjlighet",
            feedback: {
                show: {
                    disabled: "Visa inaktiverade monitorer",
                    empty: "Visa även tomma återkopplingar",
                    feedback: "Visa feedback",
                    image: "Visa bild",
                    show: "Visa feedback",
                    time: {
                        range: "Intervall",
                    },
                },
            },
            feedbackVisibility: "Responsernas synlighet",
            name: "Monitor namn",
            ratingButtons: {
                showStatus: "\"Status\"",
                showCommentsBtn: "\"Visa kommentarer\"",
                showStarBtn: "\"Markera som viktigt\"",
                showHideBtn: "\"Göm undan synen\"",
                showCloseBtn: "\"Radera\"-knapp",
                showPublishBtn: "\"Publicera\"",
                showLikeBtn: "\"Tummen upp\"",
            },
            showImage: "Visa bilder",
            showDisabled: "Visa inaktiverad mål",
            notificationLink: "Länk till aviseringar",
            comments: {
              email: "E-postkommentarer",
            },
            layout: {
                public: "Offentlig layout",
            },
            theme: "Teema",
            type: "Typ",
            security: {
                autheticated: "Autentiserat",
            },
            time: {
                dateFormat: "yyyy.MM.dd HH:mm",
                from: "Från",
                label: "Tid",
                range: "Intervall",
                timeFormat: "HH:mm",
                to: "Till",
            },
            users: "Användare",
        },
    },
};
/**/
